import React, { useEffect, useMemo, useState } from "react";

//import components
import TableContainer from '../../components/Common/DataTableContainer';
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { deleteHoliday, updateHoliday } from "store/actions";
import CreateHoliday from "./CreateHoliday";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { convertToDateOnly } from "helpers/dateFormat_helper";
import { MdDeleteOutline } from "react-icons/md";

const HolidayTable = ({ List, loading }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState();
  const [deleteId, setDeleteId] = useState();
  const [confirmAction, setConfirmAction] = useState();
  const [openModal, setOpenModal] = useState();

  const permissions = JSON.parse(localStorage?.getItem('permissions'));
  const hasDeletePermission = permissions.some(item => item?.permissionName === "Delete Holidays");

  const handleDelete = (holidayId) => {
    dispatch(deleteHoliday(holidayId));
    setDeleteId('');
    setOpenModal(false);
    setConfirmAction(false);
  };

  useEffect(() => {
    if (deleteId && confirmAction) {
      handleDelete(deleteId);
    }
  }, [deleteId, confirmAction]);

  const columns = useMemo(
    () => [
      {
        header: 'Reason',
        accessorKey: 'reason',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Date',
        accessorKey: 'date',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <span>
            {convertToDateOnly(row.original?.date)}
          </span>
        ),
      },
      ...(hasDeletePermission ? [{
        header: 'Actions',
        id: 'actions',
        cell: ({ row }) => {

          return (
            <div className="d-flex gap-2">
              {permissions?.map(item => item?.permissionName)?.includes("Delete Holidays") && <Button
                color="danger"
                onClick={() => { setDeleteId(row?.original?.holidayId); setOpenModal(true); }}
                className="mr-2"
              >
                <MdDeleteOutline size={18} />
              </Button>}
            </div>
          );
        },
      },
      ] : []),
    ],
    [hasDeletePermission]
  );

  const handleSubmit = (data) => {
    dispatch(updateHoliday(data));
  };

  const handleClose = () => {
    setIsOpen(false);
    setEditData('');
  };

  // meta title
  document.title = "Zain Channels";

  return (
    <>
      <ConfirmationModal
        okText={"Confirm"}
        onCancel={() => { setDeleteId(''); setOpenModal(false); }}
        onOk={() => { setConfirmAction(true); }}
        isVisible={openModal}
        title="Delete Holiday"
        content="Are you sure you want to delete the holiday?"
      />
      <CreateHoliday
        visible={isOpen}
        initialData={editData}
        onSubmit={handleSubmit}
        handleClose={handleClose}
      />
      <div className="">
        <div className="container-fluid">
          <TableContainer
            loading={loading}
            columns={columns}
            data={List || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder="Search..."
            pagination="pagination"
            docName="Holidays"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
    </>
  );
};

export default HolidayTable;
